var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAndroidUseModal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-android-use-modal_svg__a",
    x1: 0.404,
    y1: 0.419,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-android-use-modal_svg__b",
    x1: 0.382,
    y1: 0.068,
    x2: 0.601,
    y2: 0.868,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3fd0df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17bed0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1380"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 1346",
    stroke: "#e3e3e3",
    fill: "url(#logo-android-use-modal_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 64,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 63.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 953",
    d: "M79.613 60.953H22.468A22.521 22.521 0 010 38.384a23.414 23.414 0 011.436-8.141 22.178 22.178 0 013.989-6.8 21.552 21.552 0 0113.732-7.356 27.424 27.424 0 00-2.221 10.67h.2a30.325 30.325 0 0160.223 0h.192a29.011 29.011 0 00-2.406-10.79 8.133 8.133 0 011.284-.067 12.7 12.7 0 0112.688 12.75 12.718 12.718 0 01-6.892 11.332 12.819 12.819 0 006.767-5.945 14.713 14.713 0 015.483 11.674A15.2 15.2 0 0179.613 60.93v.022zM47.236 6.035a24.076 24.076 0 00-17.146 7.158 24.551 24.551 0 000 34.569 24.21 24.21 0 0039.49-7.77 24.553 24.553 0 00-5.2-26.8 24.076 24.076 0 00-17.144-7.157zm0 45.924a21.482 21.482 0 1121.31-21.481 21.42 21.42 0 01-21.31 21.481zm-6.6-34.851a3.792 3.792 0 00-3.74 3.779V40.63a3.779 3.779 0 107.558 0V36.6h6.877a9.746 9.746 0 000-19.485H40.633zM51.1 29.85h-6.648v-6H51.1a3 3 0 010 6z",
    transform: "translate(16.761 30.475)",
    fill: "url(#logo-android-use-modal_svg__b)"
  }))));
}
export default SvgLogoAndroidUseModal;